import type { ConcreteComponent } from 'vue';
import type {
    Sku,
    SiteMembershipContext,
    FileUploadInputValue,
    ProductSelectorSelectedPath
} from '~/types';

export enum ClaimStatus {
    incomplete = 'incomplete',
    submitted = 'submitted',
    denied = 'denied',
    approved = 'approved',
    completed = 'completed',
    canceled = 'canceled'
}

export interface ClaimFile {
    uid: Nullable<string>;
    file: string;
    claimUid: string;
}

export interface Claim {
    uid?: Readonly<string>;
    id?: Readonly<number>;
    claimNo?: Readonly<Nullable<string>>;
    sku?: Readonly<Nullable<Partial<Sku>>>;
    isEditable?: Readonly<Nullable<boolean>>;
    isIncomplete?: Readonly<Nullable<boolean>>;
    status: Readonly<ClaimStatus>;
    enteredSerialCode: Nullable<string>;
    matchedSerialCode: Nullable<string>;
    created: Nullable<string>;
    credit: Nullable<number>;
    purchaseDate: Nullable<string>;
    submittedBy: Nullable<string>;
    /**
    *  @deprecated
    */
    description: Nullable<string>;
    noProofExplanation: Nullable<string>;
    playerAge: Nullable<number>;
    useDescription: Nullable<string>;
    damageDescription: Nullable<string>;
    breakLocation: Nullable<number>;
    files: ClaimFile[];
    registrationUid: Nullable<string>;
    skuUid: Nullable<string>;
    freeShipping: Nullable<boolean>;
    purchasedFrom: Nullable<string>;
    proofOfPurchase: Nullable<string>;
    purchaseType: Nullable<SiteMembershipContext>;
}

export interface ClaimInternal {
    isProductSelector: boolean;
    productUid: Nullable<string>;
    filesUnprocessed: Nullable<FileUploadInputValue>;
    proofOfPurchaseUnprocessed: Nullable<FileUploadInputValue>;
    prodSelectedPath: ProductSelectorSelectedPath;
}

export type ClaimFrom = Claim & ClaimInternal;

export interface ClaimFormStepsConfig {
    idx: number;
    id: number;
    prevStep: number;
    nextStep: number;
}

export interface ClaimFormStepsConfigObj {
    selectProd: ClaimFormStepsConfig;
    selectSku: ClaimFormStepsConfig;
    damageProofUpload: ClaimFormStepsConfig;
    proofOfPurchase: ClaimFormStepsConfig;
    confirmation: ClaimFormStepsConfig;
    [key: string]: ClaimFormStepsConfig;
};


export interface ClaimFormStepItem {
    title: string;
    value: string;
    component: ConcreteComponent | string;
};
